import { Client, Functions } from "appwrite";

export const client = new Client();

client.setEndpoint("https://api.ai-readiness.app/v1").setProject("aireadinessindexpayment"); // Replace with your project ID

export const functions = new Functions(client);
